// src/pages/AcademyFeatures.jsx
import React, { useEffect, useRef } from "react";
import './academy-features.css'

export default function AcademyFeatures() {
  const vidsRef = useRef([]);

  useEffect(() => {
    // Fade-in ONLY the text/content, not the video frames
    const contentEls = Array.from(document.querySelectorAll(".af-fade"));
    if (contentEls.length) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("is-in");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -12% 0px" }
      );
      contentEls.forEach((el) => io.observe(el));
      return () => io.disconnect();
    }
  }, []);

  useEffect(() => {
    // Autoplay/pause videos based on visibility — no animation classes on the video containers
    const vids = vidsRef.current.filter(Boolean);
    if (!vids.length) return;

    const vio = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting) {
            try {
              v.muted = true;
              v.playsInline = true;
              const p = v.play();
              if (p && p.catch) p.catch(() => {});
            } catch {}
          } else {
            try { v.pause(); } catch {}
          }
        });
      },
      { threshold: 0.35, rootMargin: "0px 0px -10% 0px" }
    );

    vids.forEach((v) => vio.observe(v));
    return () => vio.disconnect();
  }, []);

  return (
    <section className="academy-feature-section">
      {/* ====== FEATURE 1 ====== */}
      <div className="academy-feature">
        <div className="academy-feature-media">
          <video
            src="https://cosacademyassets.s3.us-east-2.amazonaws.com/StateOfArtSpaceNEW-2-2.mp4"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            poster="https://cosacademyassets.s3.us-east-2.amazonaws.com/academy-link.jpg"
            ref={(el) => (vidsRef.current[0] = el)}
          />
        </div>

        <div className="academy-feature-content af-fade">
          <h2 className="academy-feature-title">Cutting Edge</h2>
          <p className="academy-feature-text">
            We have a top-notch state-of-the-art facility, and we teach the latest in permanent
            cosmetics techniques, so our students are always leading the way in the industry.
            <br />
            <br />
            We designed our space to be exceptionally creative and inviting because we know that the
            perfect blend of inspiration, motivation, and a picturesque backdrop is a recipe for
            success. ✨ Whether you’re capturing the essence of your work or showcasing your portfolio,
            having an inspiring environment can truly elevate your creativity — and take your work,
            and your portfolio, to the next level.
          </p>
          <a
            href="https://cosacademyassets.s3.us-east-2.amazonaws.com/CosmetinkAcademyWalkthruVideo.mp4"
            target="_blank"
            rel="noopener noreferrer"
            className="academy-feature-link"
          >
            See a full walkthrough →
          </a>
        </div>
      </div>

      {/* ====== FEATURE 2 ====== */}
      <div className="academy-feature reverse">
        <div className="academy-feature-media">
          <video
            src="https://cosacademyassets.s3.us-east-2.amazonaws.com/SampleVidKitCosmetinkAcademy2.mp4"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            poster="https://cosacademyassets.s3.us-east-2.amazonaws.com/academy-link.jpg"
            ref={(el) => (vidsRef.current[1] = el)}
          />
        </div>

        <div className="academy-feature-content af-fade">
          <h2 className="academy-feature-title">Superior Quality Products</h2>
          <p className="academy-feature-text">
            Available exclusively through COSMETINK®, our machine courses come with our Signature
            InkBrush™ Machine — the newest innovation in machine technology in the world of Permanent
            Makeup.
            <br />
            <br />
            All courses come with kits full of top-quality products and machines. Our Academy prides
            itself in ensuring our students are equipped with the latest techniques, products, and
            knowledge of market trends. We carefully select clinically trusted brands that feature
            high-end pigments and mechanics for our students.
          </p>
          <a
            href="https://cosacademyassets.s3.us-east-2.amazonaws.com/FullKitCosmetinkAcademyVideo.mp4"
            target="_blank"
            rel="noopener noreferrer"
            className="academy-feature-link"
          >
            See the full video →
          </a>
        </div>
      </div>
    </section>
  );
}
